"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VolumeControl = void 0;
const preact_1 = require("preact");
const style_1 = require("./style");
class VolumeControl extends preact_1.Component {
    constructor(props) {
        super(props);
        this.onVolumeChange = () => {
            this.setState({
                volume: this.props.game.soundSystem.getVolume()
            });
        };
        this.onClick = (e) => {
            const rects = e.currentTarget.getClientRects()[0];
            const volume = 1 - (rects.right - e.pageX) / (rects.right - rects.left);
            this.props.game.soundSystem.setVolume(volume);
        };
        this.onMouseEnter = () => {
            this.setState({
                ghostKnobActive: true
            });
        };
        this.onMouseMove = (e) => {
            if (!this.state.ghostKnobActive) {
                return;
            }
            const rects = e.currentTarget.getClientRects()[0];
            const volumePos = 1 - (rects.right - e.pageX) / (rects.right - rects.left);
            const pos = Math.min(95, Math.max(5, volumePos * 100)) + '%';
            this.setState({
                ghostKnobPos: pos
            });
        };
        this.onMouseLeave = () => {
            this.setState({
                ghostKnobActive: false
            });
        };
        this.state = {
            volume: props.game.soundSystem.getVolume(),
            ghostKnobActive: false,
            ghostKnobPos: '5%'
        };
    }
    componentDidMount() {
        this.offVolumeChange = this.props.game.soundSystem.events.on('volumeChange', this.onVolumeChange);
    }
    componentWillUnmount() {
        this.offVolumeChange && this.offVolumeChange();
    }
    render() {
        const volumePos = this.state.volume * 100;
        const knobOff = Math.min(95, Math.max(5, volumePos)) + '%';
        const lineOff = Math.min(95, Math.max(5, 100 - volumePos)) + '%';
        return ((0, preact_1.h)("div", { class: style_1.VolumeControl.control, onClick: this.onClick, onMouseEnter: this.onMouseEnter, onMouseMove: this.onMouseMove, onMouseLeave: this.onMouseLeave },
            (0, preact_1.h)("div", { class: style_1.VolumeControl.ghostLine }),
            (0, preact_1.h)("div", { class: style_1.VolumeControl.line, style: { right: lineOff } }),
            (0, preact_1.h)("div", { class: style_1.VolumeControl.knob, style: { left: knobOff } }),
            (0, preact_1.h)("div", { class: style_1.VolumeControl.ghostKnob, style: { left: this.state.ghostKnobPos } })));
    }
}
exports.VolumeControl = VolumeControl;
